import { studentRoutes } from 'src/routes'
import RoleLayout from './RoleLayout'

const StudentLayout = () => <RoleLayout allowedProfile="Student" routes={studentRoutes} />

export default StudentLayout
